<app-equifax-detail-card 
    [guest]="guest"
    [title]="title" 
    [trustDecision]="trustDecision"
    [data]="data">
</app-equifax-detail-card>